export const PLANNED_DELIVERY_WINDOWS_MAX_NAMES_BEFORE_COUNT = 3;

export const EXCLUSION_WINDOWS_CSV_IMPORT_FF = 'exclusion_windows_csv_import';
export const ENABLE_IMPROVED_EXCLUSION_WINDOWS_UX = 'enable_improved_exclusion_windows_ux';
export const DELIVERY_SLOTS_UI_IMPROVEMENT_FF = 'delivery_slots_ui_improvement';
export const ENABLE_FILL_RATIO_DATA = 'enable_fill_ratio_data';
export const DELIVERY_WINDOWS_TASKS_CAPACITY_FRONTEND_FF = 'delivery_windows_tasks_capacity_frontend';
